import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _merge from "lodash/merge";
import _compact from "lodash/compact";
import _flattenDeep from "lodash/flattenDeep";

/**
 * Merges { className, style } objects together into a single object.
 */
var mergeStyles = function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _args$reduce = args.reduce(function (memo, _ref) {
    var className = _ref.className,
        style = _ref.style;
    memo.classNameProps.push(className);
    memo.styleProps.push(style);
    return memo;
  }, {
    classNameProps: [],
    styleProps: []
  }),
      classNameProps = _args$reduce.classNameProps,
      styleProps = _args$reduce.styleProps;

  classNameProps = _flattenDeep(_compact(classNameProps));
  styleProps = _flattenDeep(_compact(styleProps));
  return {
    className: classNameProps.length ? classNameProps.join(' ') : undefined,
    style: styleProps.length ? _merge.apply(void 0, [{}].concat(_toConsumableArray(styleProps))) : undefined
  };
};

export default mergeStyles;